import { Component } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { IprUpdateImportService } from '../../../../Services/ipr-update-import.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-update-import',
  templateUrl: './update-import.component.html',
  styles: [`
        .popover {color: #000;max-width: 100%;}
        .fileupload {height:auto !important;}
        .info {margin-top:25px;}
        .importerror{margin-top: 50px;border: 1px solid #00a5be;padding: 12px;}
        .importerror b{color:#949494;}
    `]
})
export class UpdateImportComponent {
  fileToUpload: File = null;
  updateForm: FormGroup;
  loginuserID: number = 0;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  tokenKey: string = '';
  SelectedTool: string;
  ImportDisable: string = '';
  ImportError: string = '';

  constructor(private readonly _service: IprUpdateImportService,
    private readonly _fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly router: Router,
    private sessionStorageService: SessionStorageService
  ) {
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.updateForm = this._fb.group({
      createdBy: this.loginuserID,
      fupdImportUpdates: null
    });
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  public uploadFile = (files) => {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
  }

  SaveIPRUpdates(updateForm: any, files) {
    this.ImportError = '';
    updateForm.value["createdBy"] = this.loginuserID;
    if (files.length === 0) {
      this.showMessage('Please select file to import', 'Import Updates', 'error');
      return;
    }

    if (!this.ValidateCSVExtension(files[0].name)) {
      this.showMessage('Please upload .CSV file only', 'Import Updates', 'error');
      return;
    }
    this.ImportDisable = 'disabled';
    this._service.IPRImportUpdates(this.updateForm, <File>files[0], this.tokenKey).subscribe(data => {
      if (data.status == 'Success') {
        this.showMessage('Updates imported successfully', 'Import Updates', 'success');
        this.unblockDocument();
        this.ImportDisable = '';
        this.router.navigate(['/admin/' + this.SelectedTool + '/updates']);
      }
      else if (data.status == 'Failure') {
        this.ImportError = data.message;
        this.unblockDocument();
        this.ImportDisable = '';
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
      this.unblockDocument();
      this.ImportDisable = '';
    });
  }
  cancelupdates() {
    this.router.navigate(['/admin/' + this.SelectedTool + '/updates']);
  }
  ValidateCSVExtension(FileName) {
    var allowedFiles = [".csv"];
    var regex = new RegExp("([a-zA-Z0-9\s_() \\.\-:])+(" + allowedFiles.join('|') + ")$");
    if (!regex.test(FileName.toLowerCase())) {
      return false;
    }
    return true;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
}